import api from './api';
import { User } from '../types';
import {
  clearSessionActivity,
  recordActivity,
  validateStoredSession,
} from './sessionManager';

export interface LoginCredentials {
  phone: string;
  password: string;
}

export interface AuthResponse {
  token: string;
  user: User;
  expires_in?: number;
}

export interface RefreshResponse {
  token: string;
  expires_in?: number;
}

export const authService = {
  login: async (credentials: LoginCredentials): Promise<AuthResponse> => {
    const response = await api.post('/api/auth/login', credentials);
    return response.data;
  },

  refreshToken: async (): Promise<string> => {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No token to refresh');
    }
    const response = await api.post<RefreshResponse>('/api/auth/refresh', { token });
    const newToken = response.data.token;
    authService.setToken(newToken);
    return newToken;
  },

  logout: async (): Promise<void> => {
    try {
      await api.post('/api/auth/logout');
    } catch (error) {
      console.error('Logout API call failed:', error);
    } finally {
      authService.clearAuth();
    }
  },

  clearAuth: (): void => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    clearSessionActivity();
  },

  getToken: (): string | null => {
    return localStorage.getItem('token');
  },

  setToken: (token: string) => {
    localStorage.setItem('token', token);
  },

  getUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  setUser: (user: User) => {
    localStorage.setItem('user', JSON.stringify(user));
  },

  isAuthenticated: (): boolean => {
    const token = localStorage.getItem('token');
    if (!token) return false;
    return validateStoredSession();
  },

  initSession: (): boolean => {
    return validateStoredSession();
  },

  touchSession: (): void => {
    recordActivity();
  },
};
